import React from 'react'
import styles from './index.module.sass'
import { connect } from 'react-redux'
import { GlobalState } from 'reducers'
import { bindActionCreators } from 'redux'
import { toggleContentOpened } from 'actions/freestyle'

interface Props {
  toggleContentOpened: (opened?: boolean) => void,
  contentOpened: boolean,
  isFreestyle: boolean
}

const FreestyleGuideButton: React.FC<Props> = ({toggleContentOpened, isFreestyle,contentOpened}) => {
  return (
    <div  className={styles.root}>
      <div style={{pointerEvents: isFreestyle ? 'auto' : 'none'}} className={styles.wrapper} onClick={() => toggleContentOpened()}>
        <div className={`${styles.layer} ${contentOpened ? styles.layer_hidden : ''}`}>
          <div className={`${styles.guide}`}></div>
          <div className={`${styles.guide} ${styles.guide_resting}`}></div>
        </div>
        <div className={`${styles.layer} ${!contentOpened ? styles.layer_hidden : ''}`}> 
          <div className={`${styles.guide} ${styles.guide_close}`}></div>
          <div className={`${styles.guide} ${styles.guide_close_resting}`}></div>
        </div>
      </div>
    </div>
  )
}

export default connect(
  (state: GlobalState) => ({
    contentOpened: state.freestyle.contentOpened,
    isFreestyle: state.freestyle.active
  }),
  dispatch => bindActionCreators({toggleContentOpened}, dispatch)
)(FreestyleGuideButton)
